import { render, staticRenderFns } from "./SignupActivate.vue?vue&type=template&id=5147e2e3&"
import script from "./SignupActivate.vue?vue&type=script&lang=js&"
export * from "./SignupActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports